<template>
  <div id="insufficient-balance-modal">
    <el-dialog title="余额不足" v-model="showModal" custom-class="recharge-dialog" :show-close="false" @close="cancel">
      <span>您的账户余额不足以支付此订单费用，请先充值</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="goRecharge">立即充值</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import utils from '../../../libs/utils';
import sensorsdata from 'sa-sdk-javascript';
import User from '../../../libs/user.js';

export default {
  name: 'insufficient-balance-modal',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    orderId: {
      type: Number,
      required: true,
      default: 0,
    },
    from: {
      type: String,
      required: true,
      default: '',
    },
    chargePrice: {
      type: Number,
      default: 0,
    },
    fromQuery: {
      type: Object,
      default: (() => {}),
    },
    fromParam: {
      type: Object,
      required: true,
      default: (() => {}),
    },
  },
  data() {
    return {
      showModal: this.value,
    };
  },
  methods: {

    // 取消
    cancel() {
      this.$emit('input', false);
    },

    // 提交订单并跳转充值页
    goRecharge() {
      MtaH5.clickStat('startcharge', { insufficient: 'true' }); // 埋点
      // 订单支付页，触发事件弹起支付弹窗
      if (this.from === 'orderComfirm') {
        sensorsdata.track('Recharge_voucher', {
          peer_name: User.peer.peer_name,
          visa_peer_id: User.peer.visa_peer_id || '',
          platform_type: 'PC',
          page_from: '支付页-余额不足充值',
        });
        this.$emit('show-recharge');
        return;
      }
      if (_.isEmpty(this.fromQuery)) {
        this.$router.push({ name: 'balance', query: { fromParam: utils.formatParam(this.fromParam), from: this.from, chargePrice: this.chargePrice } });
      } else {
        this.$router.push({ name: 'balance', query: { fromQuery: utils.formatParam(this.fromQuery), fromParam: utils.formatParam(this.fromParam), from: this.from, chargePrice: this.chargePrice } });
      }
    },
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
    },
  },
};
</script>

<style lang="less">
#insufficient-balance-modal {
  .recharge-dialog {
    width: 480px;
    text-align: center;
    border-radius: 5px;

    .el-dialog__header {
      padding-top: 48px;
    }

    .el-dialog__title {
      font-size: 22px;
      color: #333;
      font-weight: 300;
    }

    .el-dialog__body {
      font-size: 18px;
      padding: 38px 20px;
      line-height: 1.5;
    }

    .el-dialog__footer {
      text-align: center;
      padding-bottom: 38px;

      .el-button {
        width: 150px;
        font-size: 16px;

        & + .el-button {
          margin-left: 22px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/modals/insufficient-balance-modal.vue